import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { HomeSceneTypeEnum } from '@/pages/home/types';
import { ModuleConfig } from './types';

export const HOME_CUSTOM_CONFIG = {

  /** 默认配置
   * 通过资源治理平台：https://source.hellobike.cn/#/oss/upload-file 上传图片，并获取图片url
   */
  default: {
    themeConfig: {
      navbar: {
        backgroundColor: 'rgba(217, 217, 217, 0.2)',
        backgroundImage: {
          default: 'https://m.hellobike.com/resource/gallery/522/oaTdAP4U_finance-v3-home_navbar@3x.png',
          webp: 'https://m.hellobike.com/resource/gallery/522/_3Oag4cR_finance-v3-home_navbar@3x.png?x-oss-process=image/format,webp',
        },
        slotTitle: {
          default: 'https://m.hellobike.com/1ee41800_finance-home_navbar_text_logo.png',
          style: {
            height: '20px',
            marginTop: '6px',
          },
        },
      },
      header: {
        backgroundImage: {
          default: 'https://m.hellobike.com/resource/gallery/522/6QnhVVB5_finance-v3-home_body@3x.png',
          webp: 'https://m.hellobike.com/resource/gallery/522/a9aOQKtB_finance-v3-home_body@3x.png?x-oss-process=image/format,webp',
        },
        backgroundStyle: {
          width: '375px',
          height: '326px',
          background: 'rgba(217, 217, 217, 0.2)',
        },
      },
    },
  },
  /** 蓝色主题配置 */
  [PageThemeTypeEnum.BLUE_THEME]: {
    themeConfig: {
      navbar: {
        backgroundColor: 'rgba(181, 195, 245, 0.2)',
        backgroundImage: {
          default: 'https://assets.51downapp.cn/file-1755065003225-262403346.png',
          webp: 'https://assets.51downapp.cn/file-1755065204061-906296309.webp',
        },
        slotTitle: {
          default: 'https://m.hellobike.com/1ee41800_finance-home_navbar_text_logo.png',
          style: {
            height: '20px',
            marginTop: '6px',
          },
        },
      },
      header: {
        backgroundImage: {
          default: 'https://m.hellobike.com/resource/gallery/522/IH1oe8YZ_blue-home_header@3x.png',
          webp: 'https://m.hellobike.com/resource/gallery/522/wHMm93s-_blue-home_header@3x.png?x-oss-process=image/format,webp',
        },
        backgroundStyle: {
          width: '375px',
          height: '326px',
          background: 'rgba(241, 239, 239, 0.2)',
        },
      },
    },
    generalConfig: {
      productName: '哈啰臻有钱',
    },
  },
  [HomeSceneTypeEnum.POCKET_MONEY]: {
    themeConfig: {
      navbar: {
        backgroundColor: 'linear-gradient( #FFE2D7, #FFE2D7)',
        backgroundImage: {
          default: 'https://m.hellobike.com/149129a8_bg1%403x.png',
          webp: 'https://m.hellobike.com/d95b19f2_bg1%403x.webp',
        },
        slotLeftStyle: {
          color: '#242729',
        },
      },
      header: {
        containerStyle: {
          height: '107px',
        },
        backgroundStyle: {
          width: '375px',
          height: '263px',
        },
        backgroundImage: {
          default: 'https://m.hellobike.com/0b783ef7_bg2%403x.png',
          webp: 'https://m.hellobike.com/44d9609f_bg2%403x.webp',
        },
      },
    },
    moduleConfig: {
      creditSupplementaryHidden: true,
      advProductListHidden: true,
      increaseCreditZoneHidden: true,
      txxyBannerHidden: true,
      advBannersHidden: true,
      advantageListHidden: true,
      newcomerGuidetHidden: true,
      knowFinancePanelHidden: true,
      marketBannerAdvHidden: true,
      actionBtnCornerAdvHidden: true,
      attachedCardHidden: true,
      remarkText: '最终可借额度以放款方审核为准',
    },
  },
  /** TODO:  目前蓝色版本推全 后续如果要扩展其它主题色版本，对应要做适配 (如：黑金色主题) */
  [HomeSceneTypeEnum.MIDDLEINCOME]: {
    themeConfig: {
      navbar: {
        backgroundColor: 'rgba(181, 195, 245, 0.2)',
        backgroundImage: {
          default: 'https://assets.51downapp.cn/file-1755065003225-262403346.png',
          webp: 'https://assets.51downapp.cn/file-1755065204061-906296309.webp',
        },
        slotTitle: {
          default: 'https://m.hellobike.com/1ee41800_finance-home_navbar_text_logo.png',
          style: {
            height: '20px',
            marginTop: '6px',
          },
        },
      },
      header: {
        backgroundImage: {
          default: 'https://m.hellobike.com/resource/gallery/522/IH1oe8YZ_blue-home_header@3x.png',
          webp: 'https://m.hellobike.com/resource/gallery/522/wHMm93s-_blue-home_header@3x.png?x-oss-process=image/format,webp',
        },
        backgroundStyle: {
          width: '375px',
          height: '326px',
          background: 'rgba(241, 239, 239, 0.2)',
        },
      },
    },
    moduleConfig: {
      adjustQuotaInfoHidden: true,
      couponInfoHidden: true,
      identityExpiresBarHidden: true,
      remarkTextHidden: true,
      creditSupplementaryHidden: true,
    },
  },
};

/** 首页各平台的定制化配置 */
export const HOME_PLATFORM_CONFIG: Record<string, {
  moduleConfig: ModuleConfig;
}> = {
  /**
   * 微信小程序:
   * 1. 不展示-导航栏
   * 2. 不展示-弹窗、天降红包、banner、贷超、首页右下角浮标... 企微顶部广告位
   */
  wechatMini: {
    moduleConfig: {
      navbarHidden: true,
      advProductListHidden: true,
      increaseCreditZoneHidden: true,
      dailogControllerHidden: true,
      txxyBannerHidden: true,
      advBannersHidden: true,
      advHomeFloatHidden: true,
      advWecomBannerHidden: true,
    },
  },
};
